/* THE ONE, Lumière motion
   1. Door intro: her embossed double doors part with blush light on the
      first homepage visit of a session (skippable, once per session,
      replay by adding #tl-doors to the URL).
      >>> SWITCHED OFF Sept 7 2026 on her call, see shouldRunDoors(). <<<
   2. Reveal: sections fade up as they enter the viewport.
   Progressive enhancement only, without JS (or in the theme editor, or
   with reduced motion) everything renders instantly and the doors never
   appear. */
(function () {
  var html = document.documentElement;

  if (html.classList.contains('shopify-design-mode')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  html.classList.add('tl-js');

  /* ---------------- Reveal ---------------- */
  function startReveal() {
    var sections = document.querySelectorAll('main > .shopify-section');
    if (!sections.length) {
      html.classList.remove('tl-js');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('tl-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );

    var aboveFoldIndex = 0;
    sections.forEach(function (section) {
      var rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9) {
        section.style.transitionDelay = aboveFoldIndex * 90 + 'ms';
        aboveFoldIndex += 1;
        section.classList.add('tl-in');
        section.addEventListener(
          'transitionend',
          function () {
            section.style.transitionDelay = '';
          },
          { once: true }
        );
      } else {
        observer.observe(section);
      }
    });

    // Safety net: never leave content hidden
    setTimeout(function () {
      sections.forEach(function (section) {
        section.classList.add('tl-in');
      });
    }, 2500);
  }

  /* ---------------- Doors ---------------- */
  function shouldRunDoors() {
    /* ENTRY DOORS OFF — her call, Sept 7 2026. The full-screen THE|ONE
       intro cost every first-time visitor roughly four seconds before
       they saw the page. runDoors() is kept below untouched; to bring
       the doors back, restore this function's original body:
         if (!document.querySelector('main[data-template="index"]')) return false;
         var replay = location.hash.indexOf('tl-doors') !== -1;
         var seen = false;
         try { seen = sessionStorage.getItem('tl-doors-seen') === '1'; } catch (e) {}
         return replay || !seen;                                              */
    return false;
  }

  function runDoors(onDone) {
    try {
      sessionStorage.setItem('tl-doors-seen', '1');
    } catch (e) {
      /* ignore */
    }

    var overlay = document.createElement('div');
    overlay.id = 'tl-doors';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML =
      '<div class="tl-doors__panel tl-doors__panel--left"><span class="tl-doors__word">THE</span></div>' +
      '<div class="tl-doors__seam"></div>' +
      '<div class="tl-doors__panel tl-doors__panel--right"><span class="tl-doors__word">ONE</span></div>' +
      '<div class="tl-doors__hint">Tap to open</div>';
    document.body.appendChild(overlay);

    var previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    var opened = false;
    var timers = [];

    function open() {
      if (opened) return;
      opened = true;
      timers.forEach(clearTimeout);
      overlay.classList.add('tl-doors--open');
      // Content rises as the light floods out
      timers.push(setTimeout(function () {
        document.body.style.overflow = previousOverflow;
        onDone();
      }, 1500));
      timers.push(setTimeout(function () {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      }, 3000));
    }

    overlay.addEventListener('click', open);
    document.addEventListener(
      'keydown',
      function (e) {
        if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') open();
      },
      { once: true }
    );

    // The closed beat: seam breathes, then the doors part on their own
    timers.push(setTimeout(open, 1500));
  }

  /* ---------------- Boot ---------------- */
  function boot() {
    if (shouldRunDoors()) {
      runDoors(startReveal);
    } else {
      startReveal();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* THE ONE, trust line under Add to Cart
   Always on (no motion guards, shows in the editor too). Inserts a soft
   pink reassurance row right after the buy-buttons block on product
   pages, and re-inserts it if the theme re-renders the form on a
   variant change. */
(function () {
  /* v50: says FREE where the zone ships free (EU, DPD), and speaks
     German on /de, the row was English-only for her biggest market. */
  var isDe = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
  var isIt = (document.documentElement.lang || '').toLowerCase().indexOf('it') === 0;
  var EU = 'AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE'.split(',');
  var freeEU = EU.indexOf((window.Shopify && window.Shopify.country) || '') !== -1;
  var ITEMS = isDe
    ? [freeEU ? 'Kostenloser EU-Versand' : 'Versand mit Sendungsverfolgung', 'Größentausch', 'Sicherer Checkout', 'Promise Vault inklusive']
    : isIt
    ? [freeEU ? 'Spedizione gratuita in UE' : 'Spedizione tracciata', 'Cambio misura', 'Pagamento sicuro', 'Promise Vault incluso']
    : [freeEU ? 'Free EU delivery' : 'Tracked delivery', 'Size exchange', 'Secure checkout', 'Promise Vault included'];

  function buildRow() {
    var row = document.createElement('div');
    row.className = 'tl-trust';
    row.setAttribute('aria-label', 'Order reassurance');
    row.innerHTML = ITEMS.map(function (text) {
      return (
        '<span class="tl-trust__item">' +
        '<span class="tl-trust__check" aria-hidden="true">✓</span>' +
        text +
        '</span>'
      );
    }).join('');
    return row;
  }

  function ensure() {
    var main = document.querySelector('main[data-template="product"]');
    if (!main) return;
    if (main.querySelector('.tl-trust')) return;
    var buy = main.querySelector('[class*="buy-buttons-block"]');
    if (!buy) return;
    buy.insertAdjacentElement('afterend', buildRow());
  }

  function init() {
    ensure();
    var main = document.querySelector('main[data-template="product"]');
    if (!main || !('MutationObserver' in window)) return;
    // Re-add the row if a variant change re-renders the buy-buttons block
    var observer = new MutationObserver(function () {
      ensure();
    });
    observer.observe(main, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* THE ONE, payment badges under the trust line on product pages.
   Official brand icons (Shopify payment_icons set), inlined. Klarna
   leads; the caption speaks German on /de pages. Re-inserts itself
   if a variant change re-renders the form.
   2 Nov 2026, his ask: PayPal and Shop Pay added after Klarna (both are
   live at checkout; icons from activemerchant/payment_icons). */
(function () {
  var isDe = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
  var isIt = (document.documentElement.lang || '').toLowerCase().indexOf('it') === 0;

  var CAPTION = isDe
    ? 'Sichere Zahlung, auch in Raten mit Klarna'
    : isIt ? 'Metodi di pagamento sicuri'
    : 'Secure payment options';

  var REGISTRY_RULE = isDe
    ? 'Ein Ring pro Person, für immer'
    : isIt ? 'Un anello a persona, per sempre'
    : 'One ring per person, ever';

  var REGISTRY_NOTE = isDe
    ? 'Jede Bestellung wird nach dem Kauf per Identitätsprüfung bestätigt.'
    : isIt ? 'Ogni ordine viene verificato con un controllo dell’identità dopo l’acquisto.'
    : 'Every order is verified with an identity check after purchase.';

  var ICONS = {
    klarna: '<svg aria-label="Klarna" xmlns="http://www.w3.org/2000/svg" role="img" width="38" height="24" viewBox="0 0 38 24" aria-labelledby="pi-klarna" fill="none"><title id="pi-klarna">Klarna</title><rect width="38" height="24" rx="2" fill="#FFA8CD"/><rect x=".5" y=".5" width="37" height="23" rx="1.5" stroke="#000" stroke-opacity=".07"/><path d="M30.62 14.755c-.662 0-1.179-.554-1.179-1.226 0-.673.517-1.226 1.18-1.226.663 0 1.18.553 1.18 1.226 0 .672-.517 1.226-1.18 1.226zm-.33 1.295c.565 0 1.286-.217 1.686-1.068l.04.02c-.176.465-.176.742-.176.81v.11h1.423v-4.786H31.84v.109c0 .069 0 .346.175.81l-.039.02c-.4-.85-1.121-1.068-1.687-1.068-1.355 0-2.31 1.088-2.31 2.522 0 1.433.955 2.521 2.31 2.521zm-4.788-5.043c-.643 0-1.15.228-1.56 1.068l-.039-.02c.175-.464.175-.741.175-.81v-.11h-1.423v4.787h1.462V13.4c0-.662.38-1.078.995-1.078.614 0 .917.356.917 1.068v2.532h1.462v-3.046c0-1.088-.838-1.869-1.989-1.869zm-4.963 1.068l-.039-.02c.176-.464.176-.741.176-.81v-.11h-1.424v4.787h1.463l.01-2.304c0-.673.35-1.078.926-1.078.156 0 .282.02.429.06v-1.464c-.644-.139-1.22.109-1.54.94zm-4.65 2.68c-.664 0-1.18-.554-1.18-1.226 0-.673.516-1.226 1.18-1.226.662 0 1.179.553 1.179 1.226 0 .672-.517 1.226-1.18 1.226zm-.332 1.295c.565 0 1.287-.217 1.687-1.068l.038.02c-.175.465-.175.742-.175.81v.11h1.424v-4.786h-1.424v.109c0 .069 0 .346.175.81l-.038.02c-.4-.85-1.122-1.068-1.687-1.068-1.356 0-2.311 1.088-2.311 2.522 0 1.433.955 2.521 2.31 2.521zm-4.349-.128h1.463V9h-1.463v6.922zM10.136 9H8.644c0 1.236-.751 2.343-1.892 3.134l-.448.317V9h-1.55v6.922h1.55V12.49l2.564 3.43h1.892L8.293 12.64c1.121-.82 1.852-2.096 1.843-3.639z" fill="#0B051D"/></svg>',
    paypal: '<svg aria-label="PayPal" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" width="38" height="24" role="img" aria-labelledby="pi-paypal"><title id="pi-paypal">PayPal</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"/><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"/><path fill="#003087" d="M23.9 8.3c.2-1 0-1.7-.6-2.3-.6-.7-1.7-1-3.1-1h-4.1c-.3 0-.5.2-.6.5L14 15.6c0 .2.1.4.3.4H17l.4-3.4 1.8-2.2 4.7-2.1z"/><path fill="#3086C8" d="M23.9 8.3l-.2.2c-.5 2.8-2.2 3.8-4.6 3.8H18c-.3 0-.5.2-.6.5l-.6 3.9-.2 1c0 .2.1.4.3.4H19c.3 0 .5-.2.5-.4v-.1l.4-2.4v-.1c0-.2.3-.4.5-.4h.3c2.1 0 3.7-.8 4.1-3.2.2-1 .1-1.8-.4-2.4-.1-.5-.3-.7-.5-.8z"/><path fill="#012169" d="M23.3 8.1c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3-.1-.3-.1-.7-.1-1.1-.1h-3c-.1 0-.2 0-.2.1-.2.1-.3.2-.3.4l-.7 4.4v.1c0-.3.3-.5.6-.5h1.3c2.5 0 4.1-1 4.6-3.8v-.2c-.1-.1-.3-.2-.5-.2h-.1z"/></svg>',
    shoppay: '<svg aria-label="Shop Pay" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" aria-labelledby="pi-shopify_pay"><title id="pi-shopify_pay">Shop Pay</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z" fill="#000"/><path d="M35.889 0C37.05 0 38 .982 38 2.182v19.636c0 1.2-.95 2.182-2.111 2.182H2.11C.95 24 0 23.018 0 21.818V2.182C0 .982.95 0 2.111 0H35.89z" fill="#5A31F4"/><path d="M9.35 11.368c-1.017-.223-1.47-.31-1.47-.705 0-.372.306-.558.92-.558.54 0 .934.238 1.225.704a.079.079 0 00.104.03l1.146-.584a.082.082 0 00.032-.114c-.475-.831-1.353-1.286-2.51-1.286-1.52 0-2.464.755-2.464 1.956 0 1.275 1.15 1.597 2.17 1.82 1.02.222 1.474.31 1.474.705 0 .396-.332.582-.993.582-.612 0-1.065-.282-1.34-.83a.08.08 0 00-.107-.035l-1.143.57a.083.083 0 00-.036.111c.454.92 1.384 1.437 2.627 1.437 1.583 0 2.539-.742 2.539-1.98s-1.155-1.598-2.173-1.82v-.003zM15.49 8.855c-.65 0-1.224.232-1.636.646a.04.04 0 01-.069-.03v-2.64a.08.08 0 00-.08-.081H12.27a.08.08 0 00-.08.082v8.194a.08.08 0 00.08.082h1.433a.08.08 0 00.081-.082v-3.594c0-.695.528-1.227 1.239-1.227.71 0 1.226.521 1.226 1.227v3.594a.08.08 0 00.081.082h1.433a.08.08 0 00.081-.082v-3.594c0-1.51-.981-2.577-2.355-2.577zM20.753 8.62c-.778 0-1.507.24-2.03.588a.082.082 0 00-.027.109l.632 1.088a.08.08 0 00.11.03 2.5 2.5 0 011.318-.366c1.25 0 2.17.891 2.17 2.068 0 1.003-.736 1.745-1.669 1.745-.76 0-1.288-.446-1.288-1.077 0-.361.152-.657.548-.866a.08.08 0 00.032-.113l-.596-1.018a.08.08 0 00-.098-.035c-.799.299-1.359 1.018-1.359 1.984 0 1.46 1.152 2.55 2.76 2.55 1.877 0 3.227-1.313 3.227-3.195 0-2.018-1.57-3.492-3.73-3.492zM28.675 8.843c-.724 0-1.373.27-1.845.746-.026.027-.069.007-.069-.029v-.572a.08.08 0 00-.08-.082h-1.397a.08.08 0 00-.08.082v8.182a.08.08 0 00.08.081h1.433a.08.08 0 00.081-.081v-2.683c0-.036.043-.054.069-.03a2.6 2.6 0 001.808.7c1.682 0 2.993-1.373 2.993-3.157s-1.313-3.157-2.993-3.157zm-.271 4.929c-.956 0-1.681-.768-1.681-1.783s.723-1.783 1.681-1.783c.958 0 1.68.755 1.68 1.783 0 1.027-.713 1.783-1.681 1.783h.001z" fill="#fff"/></svg>',
    visa: '<svg aria-label="Visa" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" fill="none" aria-labelledby="pi-visa"><title id="pi-visa">Visa</title><rect x=".5" y=".5" width="37" height="23" rx="2.5" stroke="#000" stroke-opacity=".07" fill="none"/><path d="M35 0H3C1.3 0 0 1.3 0 3V21C0 22.7 1.4 24 3 24H35C36.7 24 38 22.7 38 21V3C38 1.3 36.6 0 35 0Z" fill="#142FBD" style="fill:#142FBD;fill:color(display-p3 0.0784 0.1843 0.7412);fill-opacity:1;"/><path d="M35 1C36.1 1 37 1.9 37 3V21C37 22.1 36.1 23 35 23H3C1.9 23 1 22.1 1 21V3C1 1.9 1.9 1 3 1H35Z" fill="#1532CB" style="fill:#1532CB;fill:color(display-p3 0.0824 0.1961 0.7961);fill-opacity:1;"/><path d="M29.5944 10.2167H29.2778C28.8556 11.2722 28.5389 11.8 28.2222 13.3833H30.2278C29.9111 11.8 29.9111 11.0611 29.5944 10.2167V10.2167ZM32.6556 16.4444H30.8611C30.7556 16.4444 30.7556 16.4444 30.65 16.3389L30.4389 15.3889L30.3333 15.1778H27.8C27.6944 15.1778 27.5889 15.1778 27.5889 15.3889L27.2722 16.3389C27.2722 16.4444 27.1667 16.4444 27.1667 16.4444H24.95L25.1611 15.9167L28.2222 8.73889C28.2222 8.21111 28.5389 8 29.0667 8H30.65C30.7556 8 30.8611 8 30.8611 8.21111L32.3389 15.0722C32.4444 15.4944 32.55 15.8111 32.55 16.2333C32.6556 16.3389 32.6556 16.3389 32.6556 16.4444V16.4444ZM18.5111 16.1278L18.9333 14.2278C19.0389 14.2278 19.1444 14.3333 19.1444 14.3333C19.8833 14.65 20.6222 14.8611 21.3611 14.7556C21.5722 14.7556 21.8889 14.65 22.1 14.5444C22.6278 14.3333 22.6278 13.8056 22.2056 13.3833C21.9944 13.1722 21.6778 13.0667 21.3611 12.8556C20.9389 12.6444 20.5167 12.4333 20.2 12.1167C18.9333 11.0611 19.3556 9.58333 20.0944 8.84444C20.7278 8.42222 21.0444 8 21.8889 8C23.1556 8 24.5278 8 25.1611 8.21111H25.2667C25.1611 8.84444 25.0556 9.37222 24.8444 10.0056C24.3167 9.79444 23.7889 9.58333 23.2611 9.58333C22.9444 9.58333 22.6278 9.58333 22.3111 9.68889C22.1 9.68889 21.9944 9.79444 21.8889 9.9C21.6778 10.1111 21.6778 10.4278 21.8889 10.6389L22.4167 11.0611C22.8389 11.2722 23.2611 11.4833 23.5778 11.6944C24.1056 12.0111 24.6333 12.5389 24.7389 13.1722C24.95 14.1222 24.6333 14.9667 23.7889 15.6C23.2611 16.0222 23.05 16.2333 22.3111 16.2333C20.8333 16.2333 19.6722 16.3389 18.7222 16.0222C18.6167 16.2333 18.6167 16.2333 18.5111 16.1278V16.1278ZM14.8167 16.4444C14.9222 15.7056 14.9222 15.7056 15.0278 15.3889C15.5556 13.0667 16.0833 10.6389 16.5056 8.31667C16.6111 8.10556 16.6111 8 16.8222 8H18.7222C18.5111 9.26667 18.3 10.2167 17.9833 11.3778C17.6667 12.9611 17.35 14.5444 16.9278 16.1278C16.9278 16.3389 16.8222 16.3389 16.6111 16.3389L14.8167 16.4444ZM5 8.21111C5 8.10556 5.21111 8 5.31667 8H8.90556C9.43333 8 9.85556 8.31667 9.96111 8.84444L10.9111 13.4889C10.9111 13.5944 10.9111 13.5944 11.0167 13.7C11.0167 13.5944 11.1222 13.5944 11.1222 13.5944L13.3389 8.21111C13.2333 8.10556 13.3389 8 13.4444 8H15.6611C15.6611 8.10556 15.6611 8.10556 15.5556 8.21111L12.2833 15.9167C12.1778 16.1278 12.1778 16.2333 12.0722 16.3389C11.9667 16.4444 11.7556 16.3389 11.5444 16.3389H9.96111C9.85556 16.3389 9.75 16.3389 9.75 16.1278L8.06111 9.58333C7.85 9.37222 7.53333 9.05556 7.11111 8.95C6.47778 8.63333 5.31667 8.42222 5.10556 8.42222L5 8.21111Z" fill="white" style="fill:white;fill-opacity:1;"/></svg>',
    mc: '<svg aria-label="Mastercard" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" fill="none" aria-labelledby="pi-master"><title id="pi-master">Mastercard</title><rect x=".5" y=".5" width="37" height="23" rx="2.5" stroke="#000" stroke-opacity=".07" fill="none"/><path d="M35 0H3C1.3 0 0 1.3 0 3V21C0 22.7 1.4 24 3 24H35C36.7 24 38 22.7 38 21V3C38 1.3 36.6 0 35 0Z" fill="#1C1C1C" style="fill:#1C1C1C;fill:color(display-p3 0.1098 0.1098 0.1098);fill-opacity:1;"/><path d="M35 1C36.1 1 37 1.9 37 3V21C37 22.1 36.1 23 35 23H3C1.9 23 1 22.1 1 21V3C1 1.9 1.9 1 3 1H35Z" fill="#232323" style="fill:#232323;fill:color(display-p3 0.1373 0.1373 0.1373);fill-opacity:1;"/><path d="M14.6364 19.2727C18.8538 19.2727 22.2727 15.8538 22.2727 11.6364C22.2727 7.41892 18.8538 4 14.6364 4C10.4189 4 7 7.41892 7 11.6364C7 15.8538 10.4189 19.2727 14.6364 19.2727Z" fill="#EB001B" style="fill:#EB001B;fill:color(display-p3 0.9216 0.0000 0.1059);fill-opacity:1;"/><path d="M23.3637 19.2727C27.5811 19.2727 31 15.8538 31 11.6364C31 7.41892 27.5811 4 23.3637 4C19.1462 4 15.7273 7.41892 15.7273 11.6364C15.7273 15.8538 19.1462 19.2727 23.3637 19.2727Z" fill="#F79E1B" style="fill:#F79E1B;fill:color(display-p3 0.9686 0.6196 0.1059);fill-opacity:1;"/><path d="M22.2727 11.6362C22.2727 9.01797 20.9637 6.72706 19 5.41797C17.0364 6.83615 15.7273 9.12706 15.7273 11.6362C15.7273 14.1452 17.0364 16.5452 19 17.8543C20.9637 16.5452 22.2727 14.2543 22.2727 11.6362Z" fill="#FF5F00" style="fill:#FF5F00;fill:color(display-p3 1.0000 0.3725 0.0000);fill-opacity:1;"/></svg>',
    amex: '<svg aria-label="American Express" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" fill="none" aria-labelledby="pi-american_express"><title id="pi-american_express">American Express</title><rect x=".5" y=".5" width="37" height="23" rx="2.5" stroke="#000" stroke-opacity=".07" fill="none"/><path d="M35 0H3C1.3 0 0 1.3 0 3V21C0 22.7 1.4 24 3 24H35C36.7 24 38 22.7 38 21V3C38 1.3 36.6 0 35 0Z" fill="#0071CE" style="fill:#0071CE;fill:color(display-p3 0.0000 0.4431 0.8078);fill-opacity:1;"/><path d="M3 0.5H35C36.3348 0.5 37.5 1.58692 37.5 3V21C37.5 22.4239 36.4239 23.5 35 23.5H3C1.66524 23.5 0.5 22.4131 0.5 21V3C0.5 1.57614 1.57614 0.5 3 0.5Z" stroke="black" stroke-opacity="0.07" style="stroke:black;stroke-opacity:0.07;"/><path d="M25.8662 6.33203V3H31L31.8662 5.5332L32.7334 3H37V14.2002H36.7998L34.8672 16.2656L36.7998 18.3594H37V21.2666H33.5996L31.9336 19.3994L30.2002 21.2666H19.4668V12.666H16L20.2666 3H24.4004L25.8662 6.33203ZM20.5996 20.2656H27V18.5322H22.666V17.3994H26.8662V15.666H22.666V14.5322H27V12.7988H20.5996V20.2656ZM30.5332 16.5322L27 20.2656H29.5996L31.8662 17.8662L34.0664 20.2656H36.7324L33.1992 16.4658L36.7324 12.7988H34.1328L31.8662 15.1992L29.7324 12.7988H27L30.5332 16.5322ZM17.666 11.7324H19.9326L20.5332 10.1992H23.999L24.666 11.7324H26.999L23.666 4.19922H20.999L17.666 11.7324ZM33.5996 4.19922L31.9326 8.86621L30.1992 4.19922H27V11.666H29.0664V6.39941L31 11.666H32.7998L34.7324 6.39941V11.666H36.7324V4.13281L33.5996 4.19922ZM23.2656 8.46582H21.2656L22.2656 5.99902L23.2656 8.46582Z" fill="white" style="fill:white;fill-opacity:1;"/></svg>',
    applepay: '<svg aria-label="Apple Pay" version="1.1" xmlns="http://www.w3.org/2000/svg" role="img" x="0" y="0" width="38" height="24" viewBox="0 0 165.521 105.965" xml:space="preserve" aria-labelledby="pi-apple_pay"><title id="pi-apple_pay">Apple Pay</title><g><g><path fill="#000" d="M43.508 35.77c1.404-1.755 2.356-4.112 2.105-6.52-2.054.102-4.56 1.355-6.012 3.112-1.303 1.504-2.456 3.959-2.156 6.266 2.306.2 4.61-1.152 6.063-2.858" /><path fill="#000" d="M45.587 39.079c-3.35-.2-6.196 1.9-7.795 1.9-1.6 0-4.049-1.8-6.698-1.751-3.447.05-6.645 2-8.395 5.1-3.598 6.2-.95 15.4 2.55 20.45 1.699 2.5 3.747 5.25 6.445 5.151 2.55-.1 3.549-1.65 6.647-1.65 3.097 0 3.997 1.65 6.696 1.6 2.798-.05 4.548-2.5 6.247-5 1.95-2.85 2.747-5.6 2.797-5.75-.05-.05-5.396-2.101-5.446-8.251-.05-5.15 4.198-7.6 4.398-7.751-2.399-3.548-6.147-3.948-7.447-4.048" /></g><g><path fill="#000" d="M78.973 32.11c7.278 0 12.347 5.017 12.347 12.321 0 7.33-5.173 12.373-12.529 12.373h-8.058V69.62h-5.822V32.11h14.062zm-8.24 19.807h6.68c5.07 0 7.954-2.729 7.954-7.46 0-4.73-2.885-7.434-7.928-7.434h-6.706v14.894z" /><path fill="#000" d="M92.764 61.847c0-4.809 3.665-7.564 10.423-7.98l7.252-.442v-2.08c0-3.04-2.001-4.704-5.562-4.704-2.938 0-5.07 1.507-5.51 3.82h-5.252c.157-4.86 4.731-8.395 10.918-8.395 6.654 0 10.995 3.483 10.995 8.89v18.663h-5.38v-4.497h-.13c-1.534 2.937-4.914 4.782-8.579 4.782-5.406 0-9.175-3.222-9.175-8.057zm17.675-2.417v-2.106l-6.472.416c-3.64.234-5.536 1.585-5.536 3.95 0 2.288 1.975 3.77 5.068 3.77 3.95 0 6.94-2.522 6.94-6.03z" /><path fill="#000" d="M120.975 79.652v-4.496c.364.051 1.247.103 1.715.103 2.573 0 4.029-1.09 4.913-3.899l.52-1.663-9.852-27.293h6.082l6.863 22.146h.13l6.862-22.146h5.927l-10.216 28.67c-2.34 6.577-5.017 8.735-10.683 8.735-.442 0-1.872-.052-2.261-.157z" /></g></g></svg>',
    gpay: '<svg aria-label="Google Pay" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" aria-labelledby="pi-google_pay"><title id="pi-google_pay">Google Pay</title><path d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z" fill="#000" opacity=".07"/><path d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32" fill="#FFF"/><path d="M18.093 11.976v3.2h-1.018v-7.9h2.691a2.447 2.447 0 0 1 1.747.692 2.28 2.28 0 0 1 .11 3.224l-.11.116c-.47.447-1.098.69-1.747.674l-1.673-.006zm0-3.732v2.788h1.698c.377.012.741-.135 1.005-.404a1.391 1.391 0 0 0-1.005-2.354l-1.698-.03zm6.484 1.348c.65-.03 1.286.188 1.778.613.445.43.682 1.03.65 1.649v3.334h-.969v-.766h-.049a1.93 1.93 0 0 1-1.673.931 2.17 2.17 0 0 1-1.496-.533 1.667 1.667 0 0 1-.613-1.324 1.606 1.606 0 0 1 .613-1.336 2.746 2.746 0 0 1 1.698-.515c.517-.02 1.03.093 1.49.331v-.208a1.134 1.134 0 0 0-.417-.901 1.416 1.416 0 0 0-.98-.368 1.545 1.545 0 0 0-1.319.717l-.895-.564a2.488 2.488 0 0 1 2.182-1.06zM23.29 13.52a.79.79 0 0 0 .337.662c.223.176.5.269.785.263.429-.001.84-.17 1.146-.472.305-.286.478-.685.478-1.103a2.047 2.047 0 0 0-1.324-.374 1.716 1.716 0 0 0-1.03.294.883.883 0 0 0-.392.73zm9.286-3.75l-3.39 7.79h-1.048l1.281-2.728-2.224-5.062h1.103l1.612 3.885 1.569-3.885h1.097z" fill="#5F6368"/><path d="M13.986 11.284c0-.308-.024-.616-.073-.92h-4.29v1.747h2.451a2.096 2.096 0 0 1-.9 1.373v1.134h1.464a4.433 4.433 0 0 0 1.348-3.334z" fill="#4285F4"/><path d="M9.629 15.721a4.352 4.352 0 0 0 3.01-1.097l-1.466-1.14a2.752 2.752 0 0 1-4.094-1.44H5.577v1.17a4.53 4.53 0 0 0 4.052 2.507z" fill="#34A853"/><path d="M7.079 12.05a2.709 2.709 0 0 1 0-1.735v-1.17H5.577a4.505 4.505 0 0 0 0 4.075l1.502-1.17z" fill="#FBBC04"/><path d="M9.629 8.44a2.452 2.452 0 0 1 1.74.68l1.3-1.293a4.37 4.37 0 0 0-3.065-1.183 4.53 4.53 0 0 0-4.027 2.5l1.502 1.171a2.715 2.715 0 0 1 2.55-1.875z" fill="#EA4335"/></svg>'
  };

  function buildRow() {
    var wrap = document.createElement('div');
    wrap.className = 'tl-pay';
    wrap.setAttribute('aria-label', 'Accepted payment methods');
    wrap.innerHTML =
      '<span class="tl-pay__caption">' + CAPTION + '</span>' +
      '<span class="tl-pay__row">' +
      ['klarna', 'paypal', 'shoppay', 'visa', 'mc', 'amex', 'applepay', 'gpay'].map(function (key) {
        return '<span class="tl-pay__badge">' + ICONS[key] + '</span>';
      }).join('') +
      '</span>';
    return wrap;
  }

  function buildRegistry() {
    var wrap = document.createElement('div');
    wrap.className = 'tl-registry';
    wrap.setAttribute('aria-label', 'One ring per person');
    wrap.innerHTML =
      '<span class="tl-registry__rule">' + REGISTRY_RULE + '</span>' +
      '<span class="tl-registry__note">' + REGISTRY_NOTE + '</span>';
    return wrap;
  }

  function ensure() {
    var main = document.querySelector('main[data-template="product"]');
    if (!main) return;
    var trust = main.querySelector('.tl-trust');
    var buy = main.querySelector('[class*="buy-buttons-block"]');
    if (!main.querySelector('.tl-registry')) {
      var anchorA = trust || buy;
      if (anchorA) anchorA.insertAdjacentElement('afterend', buildRegistry());
    }
    if (!main.querySelector('.tl-pay')) {
      var anchorB = main.querySelector('.tl-registry') || trust || buy;
      if (anchorB) anchorB.insertAdjacentElement('afterend', buildRow());
    }
  }

  function init() {
    ensure();
    var main = document.querySelector('main[data-template="product"]');
    if (!main || !('MutationObserver' in window)) return;
    var observer = new MutationObserver(function () { ensure(); });
    observer.observe(main, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   17. FILM RESCUE, autoplay that survives Low Power Mode,
   battery savers and in-app browsers. The ai video blocks ship
   a broken empty <source src=""> and retry play() exactly once
   at parse time, before any user gesture exists. This module
   adopts every autoplay video: cleans dead sources, plays on
   scroll-into-view, and re-tries inside the first real touch /
   click (a user activation, which blocked devices accept).
   ============================================================ */
(function () {
  'use strict';
  if (window.__tlFilmRescue) return;
  window.__tlFilmRescue = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  /* TikTok's in-app webview forbids inline playback, a play() that succeeds
     there gets hijacked into the native fullscreen player. Stand down. */
  if (/TikTok|musical_ly|BytedanceWebview/i.test(navigator.userAgent || '')) return;

  var films = [];

  function nearViewport(el) {
    var r = el.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    return r.bottom > -120 && r.top < h + 120;
  }

  function tryPlay(v) {
    if (!v.paused || v.ended) return;
    v.muted = true;
    v.playsInline = true;
    try {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    } catch (e) {}
  }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) tryPlay(en.target);
        });
      }, { threshold: 0.15, rootMargin: '120px 0px 120px 0px' })
    : null;

  function adopt(v) {
    if (v.__tlFilm) return;
    v.__tlFilm = true;
    films.push(v);
    /* ambient films are never meant to fullscreen, if a webview hijacks
       one into the native player, exit immediately and leave it paused */
    v.addEventListener('webkitbeginfullscreen', function () {
      try { v.webkitExitFullscreen(); } catch (e) {}
      v.pause();
    });
    var removed = false;
    Array.prototype.slice.call(v.querySelectorAll('source')).forEach(function (s) {
      if (!s.getAttribute('src')) { s.parentNode.removeChild(s); removed = true; }
    });
    if (removed && !v.currentSrc) { try { v.load(); } catch (e) {} }
    v.muted = true;
    v.playsInline = true;
    if (io) io.observe(v);
    else if (nearViewport(v)) tryPlay(v);
  }

  function collect() {
    var list = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < list.length; i++) adopt(list[i]);
  }

  function wake() {
    for (var i = 0; i < films.length; i++) {
      if (films[i].paused && nearViewport(films[i])) tryPlay(films[i]);
    }
  }
  ['touchstart', 'touchend', 'click', 'keydown'].forEach(function (t) {
    document.addEventListener(t, wake, { passive: true, capture: true });
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) wake();
  });
  window.addEventListener('pageshow', wake);

  collect();
  if ('MutationObserver' in window) {
    var pending = 0;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = requestAnimationFrame(function () { pending = 0; collect(); });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* ============================================================
   18. LOOX STARS, surface the rating under the product title.
   Reads Loox's own JSON-LD aggregateRating so the numbers stay
   true and update themselves as reviews grow. Injects nothing
   if no rating exists.
   ============================================================ */
(function () {
  'use strict';
  function init() {
    var main = document.querySelector('main[data-template="product"]');
    if (!main || document.querySelector('.tl-stars')) return;
    var rating = null, count = null;
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var d = JSON.parse(scripts[i].textContent);
        var arr = Array.isArray(d) ? d : [d];
        for (var j = 0; j < arr.length; j++) {
          var ar = arr[j] && arr[j].aggregateRating;
          if (ar && ar.ratingValue) {
            rating = parseFloat(ar.ratingValue);
            count = parseInt(ar.reviewCount || ar.ratingCount, 10) || null;
          }
        }
      } catch (e) {}
    }
    if (!rating) return;
    var h1 = main.querySelector('h1');
    if (!h1) return;
    var isDe = (document.documentElement.lang || '').indexOf('de') === 0;
    var isIt = (document.documentElement.lang || '').indexOf('it') === 0;
    var label = rating.toFixed(1) + (count ? ' · ' + count + (isDe ? ' Bewertungen' : isIt ? ' recensioni' : ' reviews') : '');
    var el = document.createElement('a');
    el.className = 'tl-stars';
    el.href = '#looxReviews';
    el.setAttribute('aria-label', label);
    el.innerHTML = '<span class="tl-stars__s">★★★★★</span><span class="tl-stars__t"></span>';
    el.querySelector('.tl-stars__t').textContent = label;
    h1.insertAdjacentElement('afterend', el);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 1500);
  setTimeout(init, 3500);
})();

/* ==================================================================
   19. HERO HEADLINE, the line as real text, not baked pixels
   ------------------------------------------------------------------
   The headline used to be burned into the hero image, so German
   visitors read English, and the words cropped away at widths where
   the frame was shorter than the file. Writing it here means it
   translates, it scales with the viewport, and the photograph can be
   cropped for composition instead of for typography.

   Uses <h1> only if the page has none, the homepage hero is the
   right h1, but never fight an existing one. Styling is §22 in
   theone-luxe.css.

   Also un-lazies the hero image: the block ships loading="lazy",
   which is exactly wrong for the largest element above the fold.
   ================================================================== */
(function () {
  var EN = 'The ring you can only buy <span class="script">Once</span>';
  var DE = 'Der Ring, den man nur <span class="script">einmal</span> kauft';
  var IT = 'L’anello che compri <span class="script">una volta sola</span>';

  function init() {
    var box = document.querySelector('[class*="ai-hero-container-"]');
    if (!box) return;

    var img = box.querySelector('[class*="ai-hero-image-"]');
    if (img && img.getAttribute('loading') === 'lazy') {
      img.setAttribute('loading', 'eager');
      img.setAttribute('fetchpriority', 'high');
    }

    if (box.querySelector('.tl-heroline')) return;
    var isDe = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
    var isIt = (document.documentElement.lang || '').toLowerCase().indexOf('it') === 0;
    var tag = document.querySelector('main h1') ? 'p' : 'h1';
    var el = document.createElement(tag);
    el.className = 'tl-heroline';
    el.innerHTML = isDe ? DE : isIt ? IT : EN;
    box.appendChild(el);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 1200);
})();

/* ==================================================================
   20. PDP proof card → "Made to be kept"
   ------------------------------------------------------------------
   Rewrites the CONTENTS of the existing tl_proof_strip card on the
   product page, keeping its border, gradient and shadow. Done here
   rather than in templates/product.json because that file is 66KB of
   her customizer state that cannot currently be round-tripped safely.

   Image paths are derived from the theme's own asset URL (read off the
   stylesheet link), so this keeps working on every future theme version
   instead of pinning a /cdn/shop/t/NN/ number that changes on each
   duplicate. If the base cannot be derived we leave the original strip
   completely alone rather than empty it.

   Styling is §25 in theone-luxe.css.
   ================================================================== */
(function () {
  function assetBase() {
    var el = document.querySelector('link[href*="theone-luxe.css"]');
    if (el) return el.href.replace(/theone-luxe\.css.*$/, '');
    el = document.querySelector('script[src*="theone-luxe.js"]');
    if (el) return el.src.replace(/theone-luxe\.js.*$/, '');
    return null;
  }

  function init() {
    var card = document.querySelector('.tl-proof__card');
    if (!card || card.getAttribute('data-tl-kept')) return;

    var base = assetBase();
    if (!base) return;   /* never wipe the strip we cannot rebuild */

    var de = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
    var it = (document.documentElement.lang || '').toLowerCase().indexOf('it') === 0;

    var tiles = [
      { img: 'tl-ill-ring-t.png', w: 320, h: 300,
        b:  de ? '925 Sterlingsilber' : it ? 'Argento 925' : '925 Sterling Silver' },
      { img: 'tl-ill-diamond-t.png', w: 323, h: 300,
        b:  de ? 'Funkelt wie ein Diamant' : it ? 'Brilla come un diamante' : 'Diamond-like sparkle' },
      { img: 'tl-ill-agreement-t.png', w: 225, h: 300,
        b:  de ? 'Love Agreement inklusive' : it ? 'Love Agreement incluso' : 'Love Agreement included' },
      { img: 'tl-ill-europe-t.png', w: 325, h: 300,
        b:  de ? 'Versand aus der EU' : it ? 'Spedito dall’Europa' : 'Ships from the EU' }
    ];

    var html =
      '<span class="tlk-eyebrow">' + (de ? 'Der THEONE Standard' : it ? 'Lo standard THEONE' : 'The THEONE Standard') + '</span>' +
      '<div class="tlk-title">Made to be kept</div>' +
      '<div class="tlk-grid">' +
      tiles.map(function (t) {
        return '<div class="tlk-col">' +
                 '<img src="' + base + t.img + '" alt="" loading="lazy" width="' + t.w + '" height="' + t.h + '">' +
                 '<b></b>' +
               '</div>';
      }).join('') +
      '</div>';

    card.setAttribute('data-tl-kept', '1');
    card.innerHTML = html;

    /* text set via textContent so copy can never inject markup */
    var cols = card.querySelectorAll('.tlk-col');
    for (var i = 0; i < cols.length; i++) {
      cols[i].querySelector('b').textContent = tiles[i].b;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 1200);
})();